import { Injectable } from '@angular/core';
//import { AuthHttp } from 'angular2-jwt';

import { Observable } from 'rxjs';

@Injectable()
export class ListService {
  public activeFilters: any = {};
  public valFiltres = {};
  public currentPage = {'proposal': 0,'project': 0, 'proposalpe': 0};
  public rowsPerPage: number = 20;

  public getSearchValues(id) { return (this.valFiltres[id]?this.valFiltres[id]:""); }

  constructor() { }
}
